import { FLAGS } from '@gozoki/feature-flags'
import { createFileRoute, Link, Navigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { CollaboratorListTable } from '~/components/routes/hr/collaborators/collaborator-list-table'
import { STAFF_READ } from '~/components/routes/hr/tabs'
import { Button } from '~/components/ui/button'
import { useFeatureFlag } from '~/hooks/useFeatureFlag'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/hr/collaborators')({
  staticData: {
    permission: STAFF_READ,
  },
  component: RouteComponent,
})
withRoutePermissions(Route)

function RouteComponent() {
  const enabled = useFeatureFlag(FLAGS.collabListViewAndImport)

  // Flag OFF → pas d'accès direct par URL : retour à la vue planning détaillée.
  if (!enabled) {
    return <Navigate to="/hr/planning/collaborators" />
  }

  return (
    <>
      <AppHeader>
        <Title>Liste des collaborateurs</Title>
      </AppHeader>

      <AppContainer>
        <div>
          <Button variant="outline" render={<Link to="/hr/planning/collaborators" />}>
            <ArrowLeft className="size-4" />
            Retour vue détaillée
          </Button>
        </div>

        <CollaboratorListTable />
      </AppContainer>
    </>
  )
}
